import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot
} from "@angular/router";
import { Observable, of as observableOf } from "rxjs";

import { ReadableApi } from "@lantern/app/core/api";

@Injectable()
export abstract class ApiResolver<M extends object> implements Resolve<M> {
  abstract getNewResource(): M;

  constructor(private api: ReadableApi<M>) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<M> {
    const id: string | number = route.params.id;
    if (id === "new") {
      return observableOf(this.getNewResource());
    }
    if (id != null && isNaN(id as any)) {
      throw new Error("Invalid id!");
    }
    return this.api.getById(id as number);
  }
}
